import React, { Component } from 'react';
import './SolicitudesComprasSinEnviar.css';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { forwardRef } from 'react';
import { FaArrowLeft, FaPlus, FaTrash } from "react-icons/fa";
import { DataGrid } from '@mui/x-data-grid';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSolicitudesComprasSinEnviar, clearErrors } from '../../../redux/actions/dataasistencialactions';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

export class SolicitudesComprasSinEnviar extends Component {

  constructor() {
    super();
    this.state = {

      errors: {},
      open: false,
      opendelete: false,
      cotizacionid: '',
      selectedFile: null,
    };

  };

  componentDidMount() {
    this.props.getSolicitudesComprasSinEnviar();
  }
  render() {
    const { solicitudes, loadingdataasistencial } = this.props.dataAsistencial;
    const { errors } = this.state;
    const { UI: { loading } } = this.props;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Link to={`/dashboard/solicitudesasistencial/missolicitudessinenviar/solicitud/${params.row.solicitudid}`} style={{ textDecoration: 'none' }}>
              <MyButton tip="Completar Solicitud">
                <FaPlus color="#03178C" className="icon-formulario" />
              </MyButton>
            </Link>
            <MyButton tip="Borrar Solicitud" onClick={() => {
              // this.handleOpenDelete(params.row.progid);
            }}>
              <FaTrash color="red" className="icon-formulario" />
            </MyButton>
          </Box>
        )
      },
      { field: 'titulo', headerName: 'Titulo', flex: 1, minWidth: 150 },
      { field: 'area', headerName: 'Area', flex: 1, minWidth: 150 },
      { field: 'servicio', headerName: 'Servicio', flex: 1, minWidth: 150 },
    ];


    let mapeosolicitudes = !loadingdataasistencial ? (
      <Box sx={{ height: 600, width: '100%', mt: 2 }}>
        <DataGrid
          rows={solicitudes || []}
          columns={columns}
          getRowId={(row) => row.solicitudid}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#1976d2',  // primary color
              color: '#ffffff',
              fontWeight: 'bold'
            },
            '& .MuiDataGrid-cell': {
              fontSize: '13px'
            }
          }}
        />
      </Box>

    ) : (<div className="div_cargando">
      <CircularProgress size={50} color="primary" className="login-progress" />
    </div>);


    return (
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <div className="titulo_section">
          <div className="titulo_clientes">
            <h1 className="text-clientes">Mis Solicitudes de Compras Sin Enviar</h1>
            <hr className="clientes_separator"></hr>

          </div>

          <div className="div_boton">
            <Link to={`/dashboard/solicitudesasistencial`}>
              <MyButton tip="Volver">
                <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
              </MyButton>
            </Link>
          </div>
        </div>


        <Grid container spacing={2}>
          <Grid item xs={12} className='table_container'>
            {mapeosolicitudes}
          </Grid>
        </Grid>
      </Box>
    )
  }
}

SolicitudesComprasSinEnviar.propTypes = {

  getSolicitudesComprasSinEnviar: PropTypes.func.isRequired,
  dataAsistencial: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,

};

const mapActionsToProps = { getSolicitudesComprasSinEnviar, clearErrors };

const mapStateToProps = (state) => ({
  dataAsistencial: state.dataAsistencial,
  UI: state.UI
})



export default connect(mapStateToProps, mapActionsToProps)(SolicitudesComprasSinEnviar);

